import { Inject, Injectable } from '@angular/core';
import { EntityTypes } from '../../entity/entity-types';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { DictionaryProcessPayload } from './models/process-payload';
import { DictionaryProcess } from './models/process';
import { DictionaryProcessListParams } from './models/process-list-params';
import { StoreBaseService } from '../../common/base.service';

@Injectable({
  providedIn: 'root'
})
export class DictionaryProcessService
  extends StoreBaseService<DictionaryProcess, DictionaryProcessPayload, DictionaryProcessListParams> {

  get entityType(): string {
    return EntityTypes.process;
  }

  get resourceName(): string {
    return 'process';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }
}
